/*import { w3cwebsocket as W3CWebSocket } from 'websocket';

const socket = new WebSocket("wss://feuerwehr-server.org/ws");

socket.onopen = function() {
    console.log('WebSocket-Verbindung geöffnet.');
};

socket.onmessage = function(event) {
    console.log('Nachricht erhalten:', event.data);
};

socket.onclose = function(event) {
    if (event.wasClean) {
        console.log('WebSocket-Verbindung sauber geschlossen.');
    } else {
        console.error('WebSocket-Verbindung unerwartet geschlossen:', event);
    }
};

socket.onerror = function(error) {
    console.error('WebSocket-Fehler:', error);
};

export default socket;
*/
/*import { w3cwebsocket as W3CWebSocket } from 'websocket';
var active = false;
var socket = null;

if(active == false){

// websocket.js


socket = new W3CWebSocket("wss://feuerwehr-server.org:5000/ws");

socket.onopen = function() {
    console.log('WebSocket-Verbindung geöffnet.');
};

socket.onmessage = function(event) {
    console.log('Nachricht erhalten:', event.data);
};

socket.onclose = function(event) {
    if (event.wasClean) {
        console.log('WebSocket-Verbindung sauber geschlossen.');
    } else {
        console.error('WebSocket-Verbindung unerwartet geschlossen:', event);
    }
};

socket.onerror = function(error) {
    console.error('WebSocket-Fehler:', error);
};
}

export default socket;
*/

import { w3cwebsocket as W3CWebSocket } from 'websocket';

var socket = null;
var active = false;

function createSocket() {
    socket = new W3CWebSocket("wss://feuerwehr-server.org:5000/ws");

    socket.onopen = function() {
        console.log('WebSocket-Verbindung geöffnet.');
    };

    socket.onmessage = function(event) {
        console.log('Nachricht erhalten:', event.data);
    };

    socket.onclose = function(event) {
        if (event.wasClean) {
            console.log('WebSocket-Verbindung sauber geschlossen.');
        } else {
            console.error('WebSocket-Verbindung unerwartet geschlossen:', event);
            setTimeout(createSocket, 5000);  // Versuche nach 5 Sekunden, die Verbindung neu aufzubauen
        }
    };

    socket.onerror = function(error) {
        console.error('WebSocket-Fehler:', error);
    };
}

if (!active) {
    createSocket();
    active = true;
}

export default socket;
